import React, { useState } from 'react'
import { useNavigate, useParams } from 'react-router'
import { useAsync } from 'react-use'

import { Form as AntdForm, Row, Col, Card, Button, Input, Skeleton } from 'antd'
import { SaveOutlined, CloseOutlined } from '@ant-design/icons'

import { useAuth } from '../../../contexts/AuthContextProvider'
import { isAllowed } from '../../../route/roles'

const Form = () => {
  const navigate = useNavigate()
  const { firebaseApp, db, role } = useAuth()
  const { qid } = useParams()
  const [loading, setLoading] = useState(false)

  const readOnly = !isAllowed(role, 'edit', 'masters', 'questions')

  const { value } = useAsync(async () => {
    if (!qid) {
      return {}
    }

    const snap = await db.collection('/questions').doc(qid).get()
    return {
      ...snap.data(),
      id: snap.id
    }
  }, [qid])

  const handleSubmit = async (formData) => {
    try {
      setLoading(true)
      if (qid) {
        await db.collection('/questions').doc(qid).set(formData, {
          merge: true
        })
      } else {
        await db.collection('/questions').add({
          ...formData,
          createddate: firebaseApp.firestore.FieldValue.serverTimestamp()
        })
      }
      setLoading(false)
      navigate('/admin/masters/questions')
      return Promise.resolve()
    } catch (error) {
      setLoading(false)
      return Promise.reject(error)
    }
  }

  if (!value) return <Skeleton></Skeleton>
  return (
    <Card style={{ padding: 48, minHeight: '100%' }}>
      <div style={{ marginBottom: 16, fontSize: 24 }}>
        {(!qid) ? 'สร้าง' : ''}คำถามประเมิน
      </div>
      <AntdForm
        layout='vertical'
        onFinish={handleSubmit}
        initialValues={value}
      >
        <Row gutter={[24, 32]}>
          <Col span={16}>
            <AntdForm.Item name='name' label='คำถามประเมิน' rules={[{ required: true, message: 'กรุณาใส่คำถามประเมินด้วยค่ะ' }]}>
              <Input placeholder='คำถามประเมิน' disabled={readOnly} />
            </AntdForm.Item>
          </Col>
          <Col span={8}></Col>
        </Row>
        <div>
          {(!readOnly) && (
            <Button
              loading={loading}
              style={{ width: 168, height: 40, marginTop: 20, marginRight: 20 }}
              htmlType='submit'
              type='primary'
            ><SaveOutlined style={{ fontSize: 16 }} />บันทึก</Button>
          )}
          <Button
            loading={loading}
            style={{ height: 40, marginTop: 20 }}
            onClick={() => {
              navigate(-1)
            }}
          ><CloseOutlined />ปิด</Button>
        </div>
      </AntdForm>
    </Card>
  )
}

export default Form
